import { getNativeAudioContext } from '../helpers/get-native-audio-context';
const DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers'
};
export const createMediaElementAudioSourceNodeConstructor = (createNativeMediaElementAudioSourceNode, createNotSupportedError, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) => {
    return class MediaElementAudioSourceNode extends noneAudioDestinationNodeConstructor {
        constructor(context, options) {
            const nativeContext = getNativeAudioContext(context);
            if (isNativeOfflineAudioContext(nativeContext)) {
                throw createNotSupportedError();
            }
            const mergedOptions = Object.assign({}, DEFAULT_OPTIONS, options);
            const nativeMediaElementAudioSourceNode = createNativeMediaElementAudioSourceNode(nativeContext, mergedOptions);
            super(context, nativeMediaElementAudioSourceNode, null);
            // Bug #63: Edge & Firefox do not expose the mediaElement yet.
            this._mediaElement = mergedOptions.mediaElement;
            this._nativeMediaElementAudioSourceNode = nativeMediaElementAudioSourceNode;
        }
        get mediaElement() {
            return (this._nativeMediaElementAudioSourceNode.mediaElement === undefined) ?
                this._mediaElement :
                this._nativeMediaElementAudioSourceNode.mediaElement;
        }
    };
};
//# sourceMappingURL=/build/es2018/factories/media-element-audio-source-node-constructor.js.map